module.exports = __webpack_public_path__ + "static/media/HostGator.44f42fe4.svg";